import React, { useCallback, useMemo } from 'react';
import { arrayOf, func, shape } from 'prop-types';
import { isEmpty, map } from 'underscore';
import classnames from 'classnames';

import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { useI18n } from '@bingads-webui-campaign-react/smart-page-context';
import { useDefaultEditorStyle } from '@bingads-webui-campaign-react/smart-component-util';
import { MessageBar } from '@fluentui/react/lib/MessageBar';
import { ItemPicker } from '@bingads-webui-campaign-react/smart-component-card';

import { professionalServicePropTypes } from '../consts/prop-types';
import { SmartProfessionalServiceEditorItemView } from './professional-service-editor-item-view';

const UnStyledSmartProfessionalServiceEditorItemList = ({
  classes,
  onEdit,
  onDelete,
  services,
}) => {
  const i18n = useI18n();
  const { infoMessageBarClassName } = useDefaultEditorStyle();

  const servicesInternal = useMemo(() => map(services, s => ({ ...s, id: s.name })), [services]);
  const getDeleteAriaLabel = useCallback((i, item) => i18n.getString(_TL_('Delete service {{name}}'), { name: item.name }), [i18n]);
  const getEditAriaLabel = useCallback((i, item) => i18n.getString(_TL_('Edit service {{name}}'), { name: item.name }), [i18n]);

  return (
    <div className="professional-service-editor-item-list">
      {
        !isEmpty(services)
          ? <ItemPicker
            numberOfItemsPerPage={4}
            items={servicesInternal}
            i18n={i18n}
            ItemComponent={SmartProfessionalServiceEditorItemView}
            onEdit={onEdit}
            onDelete={onDelete}
            getDeleteButtonAriaLabel={getDeleteAriaLabel}
            getEditButtonAriaLabel={getEditAriaLabel}
            editButtonLabel={i18n.getString(_TL_('Edit service'))}
            editable
          />
          :
          <MessageBar className={classnames(infoMessageBarClassName, classes.noData, 'no-data-info-msg')} isMultiline>
            {i18n.getString(_TL_('You don\'t have any existing services. Please add one.'))}
          </MessageBar>
      }
    </div>
  );
};

UnStyledSmartProfessionalServiceEditorItemList.propTypes = {
  classes: shape({}).isRequired,
  onEdit: func.isRequired,
  onDelete: func.isRequired,
  services: arrayOf(professionalServicePropTypes),
};

UnStyledSmartProfessionalServiceEditorItemList.defaultProps = {
  services: [],
};

export const SmartProfessionalServiceEditorItemList = withDefaultStyles(
  UnStyledSmartProfessionalServiceEditorItemList,
  (_c, { palette = {} }) => ({
    iconContainer: {
      display: 'flex',
      alignItems: 'center',
      color: palette.themeDarkAlt,
      opacity: '0.95',
    },
    iconButton: {
      background: 'rgba(255, 255, 255, 0.83)',
      border: '1px solid black',
      width: 32,
      height: 32,
      minWidth: 32,
      borderRadius: 99,
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',

      // Hide the default chevron for menu
      '& span i:not(:first-child)': {
        display: 'none',
      },
    },
    noData: {
      background: '#F3F2F0',
      padding: '24px 5px',
    },
  })
);
